import styled from '@emotion/styled'
import CommonButton from '@/components/common/Button'
import { Input, Radio as AntdRadio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { ClaimStatusCodeEnum, RequestDocumentStatusEnum, ReceivedDocumentStatusEnum } from './types'
import { css } from '@emotion/css'

const handleDisplayPolicyStatusColor = ({ status }: { status: ClaimStatusCodeEnum }) => {
  const colorSet = {
    [ClaimStatusCodeEnum.SUBMITTED]: {
      background: '#276EF1',
    },
    [ClaimStatusCodeEnum.IN_REVIEW]: {
      background: '#276EF1',
    },
    [ClaimStatusCodeEnum.PENDING_APPROVAL]: {
      background: '#276EF1',
    },
    [ClaimStatusCodeEnum.REJECTED]: {
      background: '#EF2605',
    },
    [ClaimStatusCodeEnum.REJECTED_ON_PV]: {
      background: '#EF2605',
    },
    [ClaimStatusCodeEnum.CANCELLED]: {
      background: '#EF2605',
    },
    [ClaimStatusCodeEnum.DELETED]: {
      background: '#EF2605',
    },
    [ClaimStatusCodeEnum.DOCUMENTS_REQUESTED]: {
      background: '#FFA100',
    },
    [ClaimStatusCodeEnum.PENDING_PAYMENT]: {
      background: '#009640',
    },
    [ClaimStatusCodeEnum.CREATE_PAYMENT]: {
      background: '#009640',
    },
    [ClaimStatusCodeEnum.PENDING_DOCUMENT]: {
      background: '#EF2605',
    },
    [ClaimStatusCodeEnum.COMPLETED]: {
      background: '#C2C2C2',
    },
    [ClaimStatusCodeEnum.APPROVED]: {
      background: '#009640',
    },
  }
  return colorSet[status]?.background || '#000'
}

const handleDisplayRequestDocumentStatusColor = ({
  status,
}: {
  status: RequestDocumentStatusEnum
}) => {
  const colorSet = {
    [RequestDocumentStatusEnum.NOT_USE]: {
      background: '#C2C2C2',
    },
    [RequestDocumentStatusEnum.PENDING]: {
      background: '#FFA100',
    },
    [RequestDocumentStatusEnum.UPLOADED]: {
      background: '#009640',
    },
    [RequestDocumentStatusEnum.CANCELLED]: {
      background: '#666666',
    },
  }
  return colorSet[status]?.background || '#000'
}

const handleDisplayReceivedDocumentStatusColor = ({
  status,
}: {
  status: ReceivedDocumentStatusEnum
}) => {
  const colorSet = {
    [ReceivedDocumentStatusEnum.NOT_USE]: {
      background: '#C2C2C2',
    },
    [ReceivedDocumentStatusEnum.NOT_RECEIVED]: {
      background: '#FFA100',
    },
    [ReceivedDocumentStatusEnum.RECEIVED]: {
      background: '#009640',
    },
  }
  return colorSet[status]?.background || '#000'
}

export const BoxAction = styled('div')`
  display: flex;
`

export const ButtonIcon = styled('img')`
  cursor: pointer;
  width: 20px;
  height: 20px;
`

export const BoxSearch = styled('div')`
  flex: 0 0 50%;
`

export const SearchInput = styled(Input)`
  min-width: 400px;
  max-width: 520px;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`

export const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 24px;
`

export const Button = styled(CommonButton)`
  line-height: 20px;
  padding: 10px 16px;
  width: 111px;
  margin-left: 16px;
`

export const RadioGroup = styled(AntdRadio.Group)`
  .ant-radio-button-wrapper {
    font-size: 16px !important;

    ::before {
      :hover {
        background-color: #d9d9d9 !important;
      }
    }
  }

  .ant-radio-button-wrapper-checked {
    background-color: #f6f6f6 !important;
    color: #000000 !important;
    border-color: #d9d9d9 !important;

    ::before {
      background-color: #d9d9d9 !important;

      :hover {
        background-color: #d9d9d9 !important;
      }
    }
  }
`

export const Dot = styled('div')<{
  status: ClaimStatusCodeEnum | RequestDocumentStatusEnum | ReceivedDocumentStatusEnum
}>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(props) => {
    if (Object.values(ClaimStatusCodeEnum).includes(props.status as ClaimStatusCodeEnum)) {
      return handleDisplayPolicyStatusColor({ status: props.status as ClaimStatusCodeEnum })
    }
    if (
      Object.values(RequestDocumentStatusEnum).includes(props.status as RequestDocumentStatusEnum)
    ) {
      return handleDisplayRequestDocumentStatusColor({
        status: props.status as RequestDocumentStatusEnum,
      })
    }
    if (
      Object.values(ReceivedDocumentStatusEnum).includes(props.status as ReceivedDocumentStatusEnum)
    ) {
      return handleDisplayReceivedDocumentStatusColor({
        status: props.status as ReceivedDocumentStatusEnum,
      })
    }
    return '#000'
  }};
`

export const EmptySpaceIcon = styled('div')`
  width: 20px;
  height: 20px;
`

export const SelectedRow = css`
  &&& {
    background-color: #e6f6ea !important;
  }

  &&& > td {
    background-color: #e6f6ea !important;
  }

  &&&:hover > td {
    background-color: #e6f6ea !important;
  }

  &&& > td.ant-table-cell.ant-table-cell-row-hover {
    background-color: #e6f6ea !important;
  }
`
